import { render } from "./CollectionCardContent.vue?vue&type=template&id=36ce3183&scoped=true"
import script from "./CollectionCardContent.vue?vue&type=script&lang=js"
export * from "./CollectionCardContent.vue?vue&type=script&lang=js"

import "@/Common/Styles/collectionCard.scss?vue&type=style&index=0&id=36ce3183&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ce3183"]])

export default __exports__